(() => {
  const bootedRoots = window.__mmCollectionBootedRoots
    || (window.__mmCollectionBootedRoots = new WeakSet());

  const boot = (root) => {
    if (!root || bootedRoots.has(root)) return;
    bootedRoots.add(root);

  // ---------- Analytics helper (GA4 + GTM-safe, no-op if neither is present) ----------
  function mmTrack(eventName, params) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, params || {});
      }
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(Object.assign({ event: eventName }, params || {}));
      }
      if (window.clarity && typeof window.clarity === 'function') {
        window.clarity('event', eventName);
      }
    } catch (e) { /* swallow */ }
  }

  // ---------- Grid density toggle (Horizon's filter control radios) ----------
  const grid = root.querySelector('.mm-col__grid');
  if (grid) {
    const applyLayout = (value) => {
      grid.dataset.layout = value || 'default';
      try { localStorage.setItem('mm_col_layout', value || 'default'); } catch (e) {}
    };
    // Restore saved choice
    try {
      const saved = localStorage.getItem('mm_col_layout');
      if (saved) applyLayout(saved);
    } catch (e) {}
    // Listen to any grid-layout radios on the page (they sit in the filters bar)
    document.querySelectorAll('input[name="grid"], input[name="grid-mobile"]').forEach((input) => {
      if (input.checked) applyLayout(input.value);
      input.addEventListener('change', () => {
        if (input.checked) applyLayout(input.value);
      });
    });
  }

  const sheet = root.querySelector('[data-mm-col-sheet]');
  const sheetThumb = sheet && sheet.querySelector('[data-mm-col-sheet-thumb]');
  const sheetTitle = sheet && sheet.querySelector('[data-mm-col-sheet-title]');
  const sheetPrice = sheet && sheet.querySelector('[data-mm-col-sheet-price]');
  const sheetDetails = sheet && sheet.querySelector('[data-mm-col-sheet-details]');
  const sheetClose = sheet && sheet.querySelector('[data-mm-col-sheet-close]');
  const sheetColorWrap = sheet && sheet.querySelector('[data-mm-col-sheet-color-wrap]');
  const sheetColorValue = sheet && sheet.querySelector('[data-mm-col-sheet-color-value]');
  const sheetColors = sheet && sheet.querySelector('[data-mm-col-sheet-colors]');
  const sheetSizeWrap = sheet && sheet.querySelector('[data-mm-col-sheet-size-wrap]');
  const sheetSizeValue = sheet && sheet.querySelector('[data-mm-col-sheet-size-value]');
  const sheetSizes = sheet && sheet.querySelector('[data-mm-col-sheet-sizes]');
  const sheetStock = sheet && sheet.querySelector('[data-mm-col-sheet-stock]');
  const sheetStockText = sheet && sheet.querySelector('[data-mm-col-sheet-stock-text]');
  const sheetAtc = sheet && sheet.querySelector('[data-mm-col-sheet-atc]');
  const sheetAtcLabel = sheet && sheet.querySelector('[data-mm-col-sheet-atc-label]');
  const sheetAtcPrice = sheet && sheet.querySelector('[data-mm-col-sheet-atc-price]');

  const formatMoney = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.Shopify.money_format) {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format);
    }
    return '$ ' + Math.round(cents / 100).toLocaleString('es-MX');
  };

  const isMobileSheet = () => window.matchMedia('(max-width: 749px)').matches;

  const getColorIndex = (options) => options.findIndex((o) => /color|colour|colores|colors/i.test(o.name));

  const getSizeIndex = (options) => {
    let sizeIdx = options.findIndex((o) => /talla|size|tama[ñn]o/i.test(o.name));
    if (sizeIdx < 0) {
      sizeIdx = options.findIndex((o) =>
        /title/i.test(o.name) && o.values && o.values.length > 1 && o.values[0] !== 'Default Title'
      );
    }
    return sizeIdx;
  };

  const cardDataCache = new WeakMap();
  const getCardData = (card) => {
    const cached = cardDataCache.get(card);
    if (cached) return cached;
    let variants = [];
    let options = [];
    try { variants = JSON.parse(card.querySelector('[data-mm-col-variants]')?.textContent || '[]'); } catch (e) {}
    try { options = JSON.parse(card.querySelector('[data-mm-col-options]')?.textContent || '[]'); } catch (e) {}
    // Server tuples keep collection HTML small. Expand once, on first interaction,
    // so the picker can keep using Shopify's familiar variant object shape.
    if (Array.isArray(variants[0])) {
      variants = variants.map((packed) => {
        const optionValues = Array.isArray(packed[3]) ? packed[3] : [];
        const featuredSrc = packed[4] || '';
        const lifestyleSrc = packed[5] || '';
        return {
          id: packed[0],
          available: packed[1] === 1,
          price: packed[2],
          options: optionValues,
          option1: optionValues[0] || null,
          option2: optionValues[1] || null,
          option3: optionValues[2] || null,
          featured_image: featuredSrc ? { src: featuredSrc } : null,
          lifestyle_image: lifestyleSrc ? { src: lifestyleSrc } : null
        };
      });
    }
    const data = { variants, options };
    cardDataCache.set(card, data);
    return data;
  };

  let currentState = null; // { card, variants, options, selectedColor, selectedSize }

  const optionValue = (variant, index) => {
    if (!variant || index < 0) return '';
    return variant['option' + (index + 1)] || (variant.options && variant.options[index]) || '';
  };

  const variantTitle = (variant) => {
    if (!variant) return '';
    return variant.title
      || [variant.option1, variant.option2, variant.option3].filter((value) => value && value !== 'Default Title').join(' / ');
  };

  const normalizeImageSrc = (src) => {
    if (!src) return '';
    return typeof src === 'string' && src.startsWith('//') ? `https:${src}` : src;
  };

  const withImageWidth = (src, width) => {
    if (!src) return '';
    const hashIndex = src.indexOf('#');
    const base = hashIndex >= 0 ? src.slice(0, hashIndex) : src;
    const hash = hashIndex >= 0 ? src.slice(hashIndex) : '';
    const separator = base.includes('?') ? '&' : '?';
    return `${base}${separator}width=${width}${hash}`;
  };

  const stripImageWidth = (src) => String(src || '')
    .replace(/([?&])width=\d+&/, '$1')
    .replace(/[?&]width=\d+$/, '');

  // Swap the card image to a colour variant WITHOUT killing responsiveness:
  // rebuild src + srcset from the base URL instead of forcing one fixed size.
  const setCardImage = (img, src) => {
    if (!img || !src) return;
    const base = stripImageWidth(src);
    img.src = withImageWidth(base, 800);
    img.srcset = [300, 400, 600, 800].map((w) => `${withImageWidth(base, w)} ${w}w`).join(', ');
  };

  const setCardMedia = (card, heroSrc) => {
    if (!card) return;
    const slides = card.querySelectorAll('.mm-col-card__slide');
    const heroImage = slides[0] && slides[0].querySelector('.mm-col-card__img');

    if (heroSrc && heroImage) setCardImage(heroImage, heroSrc);

    if (typeof card.mmColGoTo === 'function') card.mmColGoTo(0);
  };

  const normalizeHandle = (value) => String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/ñ/g, 'n')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const swatchFallbacks = {
    'rojo-arcilla': '#b3575a',
    'nochebuena': '#aa1829',
    'terracota': '#c9521f',
    'corazon-de-melon': '#f4c1a1',
    'melon': '#f4c1a1',
    'durazno': '#edb7a5',
    'coral': '#e89980',
    'palo-de-rosa': '#ddbead',
    'rosa-nube': '#f7c8b8',
    'rosa': '#f2c8d0',
    'lavanda': '#c9b8de',
    'lila': '#c9b8de',
    'morado': '#8a6ebf',
    'azul-marino': '#2c3e50',
    'marino': '#2c3e50',
    'azul-cielo': '#c7d9ea',
    'cielo': '#c7d9ea',
    'azul-mar': '#4a90b8',
    'azul': '#aec6e3',
    'aqua': '#88d4d4',
    'eucalipto': '#a9b0ae',
    'menta': '#c8e2cf',
    'verde': '#c4d9c6',
    'oliva': '#a9b38a',
    'amarillo': '#f3e3a8',
    'mostaza': '#d4a93a',
    'miel': '#d4a853',
    'gris-perla': '#d8dde3',
    'gris': '#c8cdd2',
    'plomo': '#7a838c',
    'blanco-nube': '#ffffff',
    'nube': '#ffffff',
    'blanco': '#ffffff',
    'white': '#ffffff',
    'crema': '#f4ebdb',
    'beige': '#d9c7a8',
    'arena': '#d9c7a8',
    'cafe': '#8b6947',
    'negro': '#1a1a1a',
    'black': '#1a1a1a'
  };

  const colorForHandle = (handle) => {
    for (const key in swatchFallbacks) {
      if (handle.includes(key)) return swatchFallbacks[key];
    }
    return '#dddddd';
  };
  const fallbackSwatchColor = (value) => {
    const parts = String(value || '').split(' - ').map((part) => colorForHandle(normalizeHandle(part)));
    if (parts.length <= 1) return parts[0] || '#dddddd';
    if (parts.length === 2) return `conic-gradient(${parts[0]} 0deg 180deg, ${parts[1]} 180deg 360deg)`;
    return `conic-gradient(${parts[0]} 0deg 120deg, ${parts[1]} 120deg 240deg, ${parts[2]} 240deg 360deg)`;
  };

  const getVariantImageSrc = (variant) => {
    if (!variant) return '';
    const mediaImage = variant.featured_media && variant.featured_media.preview_image;
    const featuredImage = variant.featured_image;
    const image = mediaImage || featuredImage;
    const src = image && (image.src || image.url || image);
    return normalizeImageSrc(src);
  };

  const findColorVariant = (variants, options, selectedColor, availableOnly = false) => {
    const colorIdx = getColorIndex(options);
    return variants.find((variant) => {
      const colorMatch = colorIdx < 0 || optionValue(variant, colorIdx) === selectedColor;
      return colorMatch && (!availableOnly || variant.available);
    }) || null;
  };

  const findColorMediaVariant = (variants, options, selectedColor) => {
    const colorIdx = getColorIndex(options);
    return variants.find((variant) => {
      const colorMatch = colorIdx < 0 || optionValue(variant, colorIdx) === selectedColor;
      return colorMatch && (variant.featured_image || variant.lifestyle_image);
    }) || null;
  };

  const getCardSwatchColor = (card, value) => {
    const swatch = card && Array.from(card.querySelectorAll('.mm-col-card__swatch')).find((button) => button.dataset.value === value);
    if (!swatch) return fallbackSwatchColor(value);
    const inline = swatch.style.getPropertyValue('--swatch');
    const computed = window.getComputedStyle(swatch).getPropertyValue('--swatch');
    return (inline || computed || '').trim() || fallbackSwatchColor(value);
  };

  const getDisplayVariant = () => {
    if (!currentState) return null;
    const { variants, options, selectedColor } = currentState;
    return findMatchingVariant()
      || findColorVariant(variants, options, selectedColor, true)
      || findColorVariant(variants, options, selectedColor, false)
      || variants[0]
      || null;
  };

  function updateSheetThumb() {
    if (!currentState || !sheetThumb) return;
    const displayVariant = getDisplayVariant();
    const mediaVariant = findColorMediaVariant(
      currentState.variants,
      currentState.options,
      currentState.selectedColor
    );
    const variantSrc = getVariantImageSrc(mediaVariant) || getVariantImageSrc(displayVariant);
    if (variantSrc) {
      sheetThumb.src = withImageWidth(variantSrc, 200);
      sheetThumb.alt = currentState.card.dataset.productTitle || '';
      return;
    }
    const firstImg = currentState.card.querySelector('.mm-col-card__img');
    if (firstImg) {
      sheetThumb.src = firstImg.currentSrc || firstImg.src;
      sheetThumb.alt = firstImg.alt || currentState.card.dataset.productTitle || '';
    }
  }

  // ---------- Per-card init (reusable for load-more and filter/sort morphs) ----------
  // WeakSet, not a data attribute: Horizon's filter morph strips attributes that
  // are missing from the server HTML while keeping retained elements' listeners,
  // so an attribute guard would re-init retained cards and double-bind them.
  // Per-node listener guard. initCard is re-run after Horizon's filter/sort morph,
  // which can replace a card's children after the card was first initialised, so
  // every listener is bound at most once per node instead of once per card.
  const boundTypes = new WeakMap();
  const bindOnce = (node, type, fn, opts) => {
    if (!node) return;
    let set = boundTypes.get(node);
    if (!set) { set = new Set(); boundTypes.set(node, set); }
    if (set.has(type)) return;
    set.add(type);
    node.addEventListener(type, fn, opts);
  };
  const docBoundCards = new WeakSet();
  const wishSubscribed = new WeakSet();
  function initCard(card) {

    // ---- Wishlist heart (anonymous, localStorage via MMWishlist) ----
    const wishBtn = card.querySelector('[data-mm-col-wishlist]');
    if (wishBtn) {
      // Read CURRENT data attributes at click time (variant may have changed via swatch)
      const buildWishData = () => ({
        productId: wishBtn.dataset.productId,
        variantId: wishBtn.dataset.variantId,
        variantTitle: wishBtn.dataset.variantTitle,
        sizePicked: false, // collection: size auto-picked, user only chose color
        handle: wishBtn.dataset.productHandle,
        title: wishBtn.dataset.productTitle,
        url: wishBtn.dataset.productUrl,
        imageUrl: wishBtn.dataset.imageUrl,
        price: parseInt(wishBtn.dataset.productPrice || '0', 10),
        source: 'collection_card'
      });
      const syncWishBtn = () => {
        const pid = wishBtn.dataset.productId;
        const vid = wishBtn.dataset.variantId || '';
        const isIn = window.MMWishlist ? window.MMWishlist.isInList(pid, vid) : false;
        wishBtn.classList.toggle('is-active', isIn);
        wishBtn.setAttribute('aria-pressed', isIn ? 'true' : 'false');
        wishBtn.setAttribute('aria-label', isIn ? 'Quitar de favoritos' : 'Guardar en favoritos');
      };
      // Re-sync heart state whenever swatch dispatches variant-sync event
      bindOnce(wishBtn, 'mm:variant-sync', syncWishBtn);
      bindOnce(wishBtn, 'click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!window.MMWishlist) return;
        // Color matters, size is auto-picked (first available variant for selected color)
        // The swatch click handler already syncs wishBtn.dataset.variantId to that variant.
        // For different sizes, user can go to PDP.
        window.MMWishlist.toggle(buildWishData());
      });
      const subscribe = () => {
        window.MMWishlist.on((event) => {
          if (event === 'ready' || event === 'added' || event === 'removed' || event === 'synced' || event === 'cleared') {
            syncWishBtn();
          }
        });
      };
      if (!wishSubscribed.has(wishBtn)) {
        wishSubscribed.add(wishBtn);
        if (window.MMWishlist) {
          subscribe();
        } else {
          const poll = setInterval(() => {
            if (window.MMWishlist) { clearInterval(poll); subscribe(); }
          }, 150);
          setTimeout(() => clearInterval(poll), 6000);
        }
      }
    }

    const track = card.querySelector('[data-mm-col-track]');
    const media = card.querySelector('[data-mm-col-media]');
    const mediaLink = card.querySelector('.mm-col-card__media-link');
    const slides = card.querySelectorAll('.mm-col-card__slide');
    const dots = card.querySelectorAll('[data-mm-col-dots] .mm-col-card__dot');
    let idx = 0;
    let didSwipe = false;

    const goTo = (i) => {
      if (!slides.length) return;
      const visibleCount = slides[1] && slides[1].hidden ? 1 : slides.length;
      idx = Math.max(0, Math.min(visibleCount - 1, i));
      if (track) track.style.transform = `translate3d(${-idx * 100}%, 0, 0)`;
      dots.forEach((d, di) => d.classList.toggle('is-active', di === idx));
    };
    card.mmColGoTo = goTo;

    dots.forEach((d) => bindOnce(d, 'click', (e) => { e.preventDefault(); goTo(Number(d.dataset.index)); }));

    if (slides.length > 1 && track && media) {
      let x = 0, y = 0, dx = 0, dy = 0;
      bindOnce(media, 'touchstart', (e) => {
        const touch = e.touches && e.touches[0];
        if (!touch) return;
        x = touch.clientX;
        y = touch.clientY;
        dx = 0;
        dy = 0;
        didSwipe = false;
      }, { passive: true });
      bindOnce(media, 'touchmove', (e) => {
        const touch = e.touches && e.touches[0];
        if (!touch) return;
        dx = touch.clientX - x;
        dy = touch.clientY - y;
      }, { passive: true });
      bindOnce(media, 'touchend', () => {
        if (Math.abs(dx) > 38 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          didSwipe = true;
          goTo(idx + (dx < 0 ? 1 : -1));
          window.setTimeout(() => { didSwipe = false; }, 350);
        }
      }, { passive: true });
      if (mediaLink) {
        bindOnce(mediaLink, 'click', (e) => {
          if (!didSwipe) return;
          e.preventDefault();
          e.stopPropagation();
        });
      }
    }

    const swatches = card.querySelectorAll('.mm-col-card__swatch');
    const mainImg = card.querySelector('.mm-col-card__slide[data-index="0"] .mm-col-card__img');
    const activeSwatch = card.querySelector('.mm-col-card__swatch.is-active');

    if (activeSwatch) {
      const value = activeSwatch.dataset.value || '';
      if (value) card.dataset.selectedColor = value;
      const imgUrl = activeSwatch.dataset.image;
      if (imgUrl && mainImg && !mainImg.src.includes(imgUrl)) {
        setCardImage(mainImg, imgUrl);
      }
    }

    const syncWishBtnToSwatch = (sw) => {
      const wb = card.querySelector('[data-mm-col-wishlist]');
      if (!wb) return;
      if (sw.dataset.variantId) wb.dataset.variantId = sw.dataset.variantId;
      if (sw.dataset.variantTitle) wb.dataset.variantTitle = sw.dataset.variantTitle;
      if (sw.dataset.image) wb.dataset.imageUrl = withImageWidth(stripImageWidth(sw.dataset.image), 600);
    };

    // Carry the selected colour through to the PDP: without ?variant= the PDP
    // opens in the default colour after the shopper just picked another one.
    const syncCardLinks = (variantId) => {
      if (!variantId) return;
      if (!card.dataset.productUrlBase) {
        card.dataset.productUrlBase = (card.dataset.productUrl || '').split('?')[0];
      }
      const base = card.dataset.productUrlBase;
      if (!base) return;
      const href = base + '?variant=' + variantId;
      card.dataset.productUrl = href;
      const mediaLink = card.querySelector('.mm-col-card__media-link');
      if (mediaLink) mediaLink.href = href;
      const titleLink = card.querySelector('.mm-col-card__title-link');
      if (titleLink) titleLink.href = href;
      const wishlist = card.querySelector('[data-mm-col-wishlist]');
      if (wishlist) wishlist.dataset.productUrl = href;
    };
    // Sync on init too (in case page-load active swatch differs from data attrs)
    if (activeSwatch) syncWishBtnToSwatch(activeSwatch);
    if (activeSwatch) syncCardLinks(activeSwatch.dataset.variantId);

    swatches.forEach((sw) => {
      bindOnce(sw, 'click', (e) => {
        e.preventDefault();
        swatches.forEach((s) => {
          s.classList.toggle('is-active', s === sw);
          s.setAttribute('aria-pressed', s === sw ? 'true' : 'false');
        });
        const value = sw.dataset.value || '';
        card.dataset.selectedColor = value;
        const { variants, options } = getCardData(card);
        const mediaVariant = findColorMediaVariant(variants, options, value);
        const heroSrc = sw.dataset.image || getVariantImageSrc(mediaVariant);
        setCardMedia(card, heroSrc);
        try { mmTrack('swatch_click', { handle: card.dataset.productHandle || '', color: value }); } catch (err) {}
        // Sync wishlist heart to the selected color's first available variant
        syncWishBtnToSwatch(sw);
        syncCardLinks(sw.dataset.variantId);
        // Ofertas (discount-only cards): the swatch carries the discounted price and
        // sizes of its colour, so the price line and "Tallas en oferta" follow the colour.
        if (sw.dataset.salePrice) {
          const priceNow = card.querySelector('.mm-col-card__price-now');
          const priceWas = card.querySelector('.mm-col-card__price-was');
          const saleSizes = card.querySelector('.mm-col-card__sale-sizes');
          if (priceNow) {
            priceNow.textContent = sw.dataset.salePrice;
            priceNow.classList.add('mm-col-card__price-now--sale');
          }
          if (priceWas) priceWas.textContent = sw.dataset.saleCompare || '';
          if (saleSizes) {
            saleSizes.textContent = sw.dataset.saleSizes ? 'Tallas en oferta: ' + sw.dataset.saleSizes : '';
            saleSizes.hidden = !sw.dataset.saleSizes;
          }
          // Discount badge ("-29%") follows the colour's discounted variant too.
          const pctBadge = card.querySelector('[data-mm-col-badge-pct]');
          if (pctBadge && sw.dataset.salePct) pctBadge.textContent = '-' + sw.dataset.salePct + '%';
        }
        // Re-render heart state for the new variant
        try { card.querySelector('[data-mm-col-wishlist]')?.dispatchEvent(new CustomEvent('mm:variant-sync')); } catch (e) {}
      });
    });

    const plus = card.querySelector('[data-mm-col-plus]');
    const sizePop = card.querySelector('[data-mm-col-size-pop]');
    const sizePopPills = card.querySelector('[data-mm-col-size-pop-pills]');

    const closeSizePop = () => {
      if (!sizePop || sizePop.hidden) return;
      sizePop.hidden = true;
      plus?.setAttribute('aria-expanded', 'false');
    };

    const addVariantToCart = async (variantId) => {
      if (window.MMCart && typeof window.MMCart.add === 'function') {
        return window.MMCart.add({
          id: variantId,
          quantity: 1,
          productId: card.dataset.productId,
          sourceId: 'mm-collection'
        });
      }

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (!res.ok) throw new Error('add failed');
      await res.json();
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { data: { source: 'product-form-component', productId: card.dataset.productId, itemCount: 1 } }
      }));
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') drawer.open();
      return true;
    };

    const quickAddVariant = async (variantId) => {
      plus?.classList.add('is-loading');
      plus?.setAttribute('aria-busy', 'true');
      if (plus) plus.disabled = true;
      try {
        await addVariantToCart(variantId);
        mmTrack('quick_add_complete', {
          source: 'collection_card',
          product_id: card.dataset.productId,
          product_title: card.dataset.productTitle,
          variant_id: variantId,
          collection: (window.Shopify && Shopify.routes && Shopify.routes.root) ? location.pathname : ''
        });
      } catch (err) {
        console.error('[mm-col] quick-add failed', err);
        mmTrack('quick_add_error', {
          source: 'collection_card',
          product_id: card.dataset.productId,
          variant_id: variantId,
          error: String(err && err.message || err)
        });
      } finally {
        plus?.classList.remove('is-loading');
        plus?.removeAttribute('aria-busy');
        if (plus) plus.disabled = false;
      }
    };

    const openSizePop = (actionType = 'cart') => {
      if (!sizePop || !sizePopPills) return;
      const { variants, options } = getCardData(card);

      const colorIdx = getColorIndex(options);
      // Accept "Talla", "Size", "Tamaño/Tamano" as size axes. Treat a generic "Title" option
      // with >1 values as a size-like picker (e.g. Bolsa Pequeña / Bolsa Grande).
      let sizeIdx = getSizeIndex(options);

      const selectedColor = card.dataset.selectedColor
        || (colorIdx >= 0 ? options[colorIdx].values[0] : '');

      // Helper: pick the first matching+available variant, falling back to ANY available variant.
      const pickAvailable = (filterFn) => {
        const match = variants.find((v) => v.available && (!filterFn || filterFn(v)));
        if (match) return match;
        return variants.find((v) => v.available) || null;
      };

      // Helper: dispatch the chosen variant to the right action (cart or wishlist)
      const dispatchVariant = (variant) => {
        if (actionType === 'wishlist') {
          if (!window.MMWishlist || !variant) return;
          const mediaVariant = findColorMediaVariant(variants, options, selectedColor);
          window.MMWishlist.toggle({
            productId: card.dataset.productId,
            variantId: String(variant.id),
            variantTitle: variantTitle(variant),
            handle: card.dataset.productHandle,
            title: card.dataset.productTitle,
            url: '/products/' + card.dataset.productHandle,
            imageUrl: (getVariantImageSrc(mediaVariant) && withImageWidth(stripImageWidth(getVariantImageSrc(mediaVariant)), 600)) || card.querySelector('[data-mm-col-wishlist]')?.dataset.imageUrl || '',
            price: variant.price,
            source: 'collection_card_picker'
          });
          closeSizePop();
        } else {
          quickAddVariant(variant.id);
        }
      };

      const availableColorCount = String(card.dataset.visibleColors || '').split('|').filter(Boolean).length;

      // No size option but multiple colours: open the sheet so colour-only
      // products still expose a visible choice instead of silently quick-adding.
      if (sizeIdx < 0) {
        if (actionType === 'cart' && colorIdx >= 0 && availableColorCount > 1) {
          openSheet(card);
          return;
        }

        const matching = pickAvailable((v) => {
          if (colorIdx < 0) return true;
          return v['option' + (colorIdx + 1)] === selectedColor;
        });
        if (matching) {
          dispatchVariant(matching);
        } else {
          // Whole product is sold out: open the picker so the user sees the state.
          if (actionType === 'cart' && isMobileSheet()) {
            openSheet(card);
          } else {
            renderPicker(variants, options, colorIdx, sizeIdx, selectedColor, actionType);
          }
        }
        return;
      }

      // Size option exists but only ONE value total → add directly if available.
      const sizesForColor = variants
        .filter((v) => colorIdx < 0 || v['option' + (colorIdx + 1)] === selectedColor);
      const sizesForColorAvail = sizesForColor.filter((v) => v.available);
      if (sizesForColorAvail.length === 1 && sizesForColor.length === 1) {
        dispatchVariant(sizesForColorAvail[0]);
        return;
      }
      if (actionType === 'cart' && isMobileSheet()) {
        openSheet(card);
        return;
      }
      renderPicker(variants, options, colorIdx, sizeIdx, selectedColor, actionType);
    };

    const renderPicker = (variants, options, colorIdx, sizeIdx, selectedColor, actionType = 'cart') => {
      if (sizeIdx < 0) {
        // No size axis identified but product is sold out — just show a single Agotado pill
        sizePopPills.innerHTML = '';
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mm-col-card__size-pill is-unavailable';
        btn.disabled = true;
        btn.textContent = 'Agotado';
        sizePopPills.appendChild(btn);
        sizePop.hidden = false;
        plus?.setAttribute('aria-expanded', 'true');
        mmTrack('quick_add_no_stock', {
          source: 'collection_card',
          product_id: card.dataset.productId,
          product_title: card.dataset.productTitle
        });
        return;
      }

      sizePopPills.innerHTML = '';
      options[sizeIdx].values.forEach((sizeVal) => {
        const matching = variants.find((v) => {
          const sKey = 'option' + (sizeIdx + 1);
          const cKey = colorIdx >= 0 ? 'option' + (colorIdx + 1) : null;
          const sMatch = v[sKey] === sizeVal;
          const cMatch = cKey ? v[cKey] === selectedColor : true;
          return sMatch && cMatch;
        });
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mm-col-card__size-pill';
        btn.textContent = sizeVal;
        btn.dataset.value = sizeVal;
        if (!matching || !matching.available) btn.classList.add('is-unavailable');
        bindOnce(btn, 'click', async (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (!matching || !matching.available || btn.disabled) return;
          if (actionType === 'wishlist') {
            // Wishlist path: toggle via MMWishlist, close sheet, no cart dispatch
            if (!window.MMWishlist) return;
            mmTrack('quick_wish_size_select', {
              source: 'collection_card',
              product_id: card.dataset.productId,
              product_title: card.dataset.productTitle,
              size: sizeVal,
              variant_id: matching.id
            });
            const mediaVariant = findColorMediaVariant(variants, options, selectedColor);
            window.MMWishlist.toggle({
              productId: card.dataset.productId,
              variantId: String(matching.id),
              variantTitle: variantTitle(matching),
              handle: card.dataset.productHandle,
              title: card.dataset.productTitle,
              url: '/products/' + card.dataset.productHandle,
              imageUrl: (getVariantImageSrc(mediaVariant) && withImageWidth(stripImageWidth(getVariantImageSrc(mediaVariant)), 600)) || card.querySelector('[data-mm-col-wishlist]')?.dataset.imageUrl || '',
              price: matching.price,
              source: 'collection_card_picker'
            });
            closeSizePop();
            return;
          }
          mmTrack('quick_add_size_select', {
            source: 'collection_card',
            product_id: card.dataset.productId,
            product_title: card.dataset.productTitle,
            size: sizeVal,
            variant_id: matching.id
          });
          btn.disabled = true;
          const prevText = btn.textContent;
          btn.textContent = '…';
          try {
            await addVariantToCart(matching.id);
            mmTrack('quick_add_complete', {
              source: 'collection_card_picker',
              product_id: card.dataset.productId,
              product_title: card.dataset.productTitle,
              size: sizeVal,
              variant_id: matching.id
            });
            closeSizePop();
          } catch (err) {
            btn.textContent = 'Error';
            setTimeout(() => { btn.textContent = prevText; btn.disabled = false; }, 900);
            mmTrack('quick_add_error', {
              source: 'collection_card_picker',
              product_id: card.dataset.productId,
              variant_id: matching.id,
              error: String(err && err.message || err)
            });
          }
        });
        sizePopPills.appendChild(btn);
      });

      sizePop.hidden = false;
      plus?.setAttribute('aria-expanded', 'true');
    };

    if (plus) {
      bindOnce(plus, 'click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (sizePop && !sizePop.hidden) { closeSizePop(); return; }
        // Close any other open size popovers first
        root.querySelectorAll('[data-mm-col-size-pop]').forEach((p) => { if (p !== sizePop) p.hidden = true; });
        root.querySelectorAll('[data-mm-col-plus]').forEach((b) => { if (b !== plus) b.setAttribute('aria-expanded', 'false'); });
        mmTrack('quick_add_open', {
          source: 'collection_card',
          product_id: card.dataset.productId,
          product_title: card.dataset.productTitle,
          selected_color: card.dataset.selectedColor,
          collection: location.pathname
        });
        openSizePop();
      });
    }

    // Close popover on outside click / Escape (once per card element)
    if (!docBoundCards.has(card)) {
      docBoundCards.add(card);
      document.addEventListener('click', (e) => {
        if (!sizePop || sizePop.hidden) return;
        if (card.contains(e.target)) return;
        closeSizePop();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeSizePop();
      });
    }
  }

  root.querySelectorAll('[data-mm-col-card]').forEach(initCard);

  // Horizon's filter/sort re-renders this section via the Section Rendering API
  // and morphs the DOM without re-running this script: re-init whatever the
  // morph added or replaced (WeakSet-guarded, so retained cards are untouched).
  if ('MutationObserver' in window) {
    let reinitTimer = null;
    const mo = new MutationObserver(() => {
      if (reinitTimer) clearTimeout(reinitTimer);
      reinitTimer = setTimeout(() => {
        root.querySelectorAll('[data-mm-col-card]').forEach(initCard);
      }, 80);
    });
    mo.observe(root, { childList: true, subtree: true });
  }

  // ---------- Load more ----------
  // Query at call time and delegate clicks to root: the filter/sort morph can
  // replace the button, the counter and the grid, leaving captured references
  // and directly-bound listeners stale.
  const getLoadMoreBtn = () => root.querySelector('[data-mm-col-loadmore]');
  if (getLoadMoreBtn() && grid) {
    let loading = false;
    let pagesLoaded = 1;
    const restoreKey = 'mmcol:' + location.pathname;

    const loadNext = async () => {
      if (loading) return false;
      const loadMoreBtn = getLoadMoreBtn();
      const grid = root.querySelector('.mm-col__grid');
      const shownEl = root.querySelector('[data-mm-col-shown]');
      if (!loadMoreBtn || !grid) return false;
      const nextUrl = loadMoreBtn.dataset.nextUrl;
      if (!nextUrl) return false;
      loading = true;
      const label = loadMoreBtn.querySelector('[data-mm-col-loadmore-label]');
      const originalLabel = label ? label.textContent : '';
      if (label) label.textContent = 'Cargando…';
      loadMoreBtn.setAttribute('aria-disabled', 'true');
      loadMoreBtn.setAttribute('aria-busy', 'true');

      try {
        const res = await fetch(nextUrl, { headers: { Accept: 'text/html' } });
        if (!res.ok) throw new Error('fetch failed');
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newItems = doc.querySelectorAll('.mm-col__grid .mm-col__item');
        newItems.forEach((item) => {
          grid.appendChild(item);
          item.querySelectorAll('[data-mm-col-card]').forEach(initCard);
        });
        if (shownEl) shownEl.textContent = grid.querySelectorAll('.mm-col__item').length;
        pagesLoaded += 1;

        const newNextBtn = doc.querySelector('[data-mm-col-loadmore]');
        if (newNextBtn && newNextBtn.dataset.nextUrl) {
          loadMoreBtn.dataset.nextUrl = newNextBtn.dataset.nextUrl;
          loadMoreBtn.href = newNextBtn.href || newNextBtn.dataset.nextUrl;
          loadMoreBtn.removeAttribute('aria-disabled');
          loadMoreBtn.removeAttribute('aria-busy');
          if (label) label.textContent = originalLabel || 'Cargar más';
        } else {
          loadMoreBtn.remove();
        }
        return true;
      } catch (e) {
        if (label) label.textContent = 'Error, reintenta';
        loadMoreBtn.removeAttribute('aria-disabled');
        loadMoreBtn.removeAttribute('aria-busy');
        return false;
      } finally {
        loading = false;
      }
    };

    root.addEventListener('click', (e) => {
      const btn = e.target && e.target.closest && e.target.closest('[data-mm-col-loadmore]');
      if (!btn) return;
      e.preventDefault();
      try { mmTrack('load_more', { page: pagesLoaded + 1 }); } catch (err) {}
      loadNext();
    });

    // Back-navigation restore: load-more state evaporates on back (products
    // 25+ were a dead zone). Save pages+scroll when leaving via a product
    // link; re-expand and restore scroll on the next fresh load.
    root.addEventListener('click', (e) => {
      const link = e.target && e.target.closest && e.target.closest('a[href*="/products/"]');
      if (!link) return;
      try {
        sessionStorage.setItem(restoreKey, JSON.stringify({ pages: pagesLoaded, y: window.scrollY, ts: Date.now() }));
      } catch (err) {}
    }, true);

    (async () => {
      let saved = null;
      try { saved = JSON.parse(sessionStorage.getItem(restoreKey) || 'null'); } catch (err) {}
      if (!saved || !saved.pages || saved.pages < 2) return;
      if (Date.now() - (saved.ts || 0) > 30 * 60 * 1000) { try { sessionStorage.removeItem(restoreKey); } catch (err) {} return; }
      try { sessionStorage.removeItem(restoreKey); } catch (err) {}
      let guard = 0;
      while (pagesLoaded < saved.pages && getLoadMoreBtn() && getLoadMoreBtn().dataset.nextUrl && guard < 10) {
        guard += 1;
        const ok = await loadNext();
        if (!ok) break;
      }
      if (saved.y) window.scrollTo(0, saved.y);
    })();
  }

  function syncCardToSheetColor(value) {
    if (!currentState || !value) return;
    const card = currentState.card;
    const swatches = card.querySelectorAll('.mm-col-card__swatch');
    const visibleSwatch = Array.from(swatches).find((sw) => sw.dataset.value === value);
    card.dataset.selectedColor = value;
    const mediaVariant = findColorMediaVariant(currentState.variants, currentState.options, value);
    const heroSrc = (visibleSwatch && visibleSwatch.dataset.image) || getVariantImageSrc(mediaVariant);

    if (visibleSwatch) {
      swatches.forEach((sw) => {
        sw.classList.toggle('is-active', sw === visibleSwatch);
        sw.setAttribute('aria-pressed', sw === visibleSwatch ? 'true' : 'false');
      });
      const wb = card.querySelector('[data-mm-col-wishlist]');
      if (wb) {
        if (visibleSwatch.dataset.variantId) wb.dataset.variantId = visibleSwatch.dataset.variantId;
        if (visibleSwatch.dataset.variantTitle) wb.dataset.variantTitle = visibleSwatch.dataset.variantTitle;
        if (visibleSwatch.dataset.image) wb.dataset.imageUrl = withImageWidth(stripImageWidth(visibleSwatch.dataset.image), 600);
        try { wb.dispatchEvent(new CustomEvent('mm:variant-sync')); } catch (e) {}
      }
    } else {
      swatches.forEach((sw) => { sw.classList.remove('is-active'); sw.setAttribute('aria-pressed', 'false'); });
    }
    setCardMedia(card, heroSrc);

    // Keep card + "Ver detalles" links pointing at the selected colour's variant
    const linkVariantId = (visibleSwatch && visibleSwatch.dataset.variantId)
      || ((findColorVariant(currentState.variants, currentState.options, value, true)
        || findColorVariant(currentState.variants, currentState.options, value, false) || {}).id);
    if (linkVariantId) {
      if (!card.dataset.productUrlBase) card.dataset.productUrlBase = (card.dataset.productUrl || '').split('?')[0];
      if (card.dataset.productUrlBase) {
        const colorHref = card.dataset.productUrlBase + '?variant=' + linkVariantId;
        card.dataset.productUrl = colorHref;
        const cardMediaLink = card.querySelector('.mm-col-card__media-link');
        if (cardMediaLink) cardMediaLink.href = colorHref;
        const cardTitleLink = card.querySelector('.mm-col-card__title-link');
        if (cardTitleLink) cardTitleLink.href = colorHref;
        const wishlist = card.querySelector('[data-mm-col-wishlist]');
        if (wishlist) wishlist.dataset.productUrl = colorHref;
        if (sheetDetails) sheetDetails.href = colorHref;
      }
    }

    if (typeof card.mmColGoTo === 'function') card.mmColGoTo(0);
  }

  function renderSheetColors() {
    if (!currentState || !sheetColors) return;
    const { variants, options, selectedColor, card } = currentState;
    const colorIdx = getColorIndex(options);
    sheetColors.innerHTML = '';

    const visibleValues = String(card.dataset.visibleColors || '').split('|').filter(Boolean);
    const values = visibleValues.length
      ? visibleValues
      : (colorIdx >= 0 && options[colorIdx]
        ? options[colorIdx].values.filter((value) => variants.some((variant) => optionValue(variant, colorIdx) === value && variant.available))
        : []);

    if (sheetColorWrap) sheetColorWrap.hidden = values.length === 0;
    if (sheetColorValue) sheetColorValue.textContent = selectedColor || '';
    if (!values.length) return;

    values.forEach((value) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mm-col-sheet__swatch';
      btn.dataset.value = value;
      btn.style.setProperty('--swatch', getCardSwatchColor(card, value));
      btn.setAttribute('aria-label', value);
      btn.setAttribute('aria-pressed', value === selectedColor ? 'true' : 'false');
      btn.classList.toggle('is-active', value === selectedColor);
      btn.addEventListener('click', () => selectSheetColor(value));
      sheetColors.appendChild(btn);
    });
  }

  function renderSheetSizes() {
    if (!currentState || !sheetSizes) return;
    const { variants, options, selectedColor } = currentState;
    const colorIdx = getColorIndex(options);
    const sizeIdx = getSizeIndex(options);
    const previousSize = currentState.selectedSize;
    let preservedSize = '';
    sheetSizes.innerHTML = '';

    if (sizeIdx < 0 || !options[sizeIdx]) {
      if (sheetSizeWrap) sheetSizeWrap.hidden = true;
      currentState.selectedSize = '';
      if (sheetSizeValue) sheetSizeValue.textContent = '';
      return;
    }

    if (sheetSizeWrap) sheetSizeWrap.hidden = false;
    options[sizeIdx].values.forEach((sizeVal) => {
      const matchingVariant = variants.find((variant) => {
        const sizeMatch = optionValue(variant, sizeIdx) === sizeVal;
        const colorMatch = colorIdx < 0 || optionValue(variant, colorIdx) === selectedColor;
        return sizeMatch && colorMatch;
      });

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mm-col-sheet__size';
      btn.dataset.value = sizeVal;
      btn.textContent = sizeVal;
      if (!matchingVariant || !matchingVariant.available) {
        btn.classList.add('is-unavailable');
        btn.disabled = true;
      }
      if (previousSize && sizeVal === previousSize && matchingVariant && matchingVariant.available) {
        preservedSize = previousSize;
        btn.classList.add('is-active');
      }
      btn.addEventListener('click', () => selectSize(sizeVal));
      sheetSizes.appendChild(btn);
    });

    currentState.selectedSize = preservedSize;
    if (sheetSizeValue) sheetSizeValue.textContent = preservedSize;

    // When exactly ONE size is in stock for this colour, preselect it so the
    // shopper doesn't have to re-state the only possible choice.
    if (!preservedSize) {
      const availableSizes = options[sizeIdx].values.filter((sizeVal) => variants.some((variant) => {
        const sizeMatch = optionValue(variant, sizeIdx) === sizeVal;
        const colorMatch = colorIdx < 0 || optionValue(variant, colorIdx) === selectedColor;
        return sizeMatch && colorMatch && variant.available;
      }));
      if (availableSizes.length === 1) selectSize(availableSizes[0]);
    }
  }

  function selectSheetColor(value) {
    if (!currentState || !value) return;
    currentState.selectedColor = value;
    syncCardToSheetColor(value);
    if (sheetColorValue) sheetColorValue.textContent = value;
    if (sheetColors) {
      sheetColors.querySelectorAll('.mm-col-sheet__swatch').forEach((button) => {
        const isActive = button.dataset.value === value;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }
    renderSheetSizes();
    updateSheetThumb();
    updateSheetState();
  }

  function openSheet(card) {
    if (!sheet) return;
    const { variants, options } = getCardData(card);

    const title = card.dataset.productTitle || '';
    const url = card.dataset.productUrl || '#';
    let selectedColor = card.dataset.selectedColor || '';
    const firstImg = card.querySelector('.mm-col-card__img');

    currentState = { card, variants, options, selectedColor, selectedSize: '' };

    sheetTitle.textContent = title;
    sheetDetails.href = url;
    if (sheetThumb && firstImg) {
      sheetThumb.src = firstImg.currentSrc || firstImg.src;
      sheetThumb.alt = firstImg.alt || title;
    }

    // Identify option positions
    const colorIdx = getColorIndex(options);
    const sizeIdx = getSizeIndex(options);

    // Default selected color if not set
    if (!currentState.selectedColor && colorIdx >= 0) {
      const visibleValues = String(card.dataset.visibleColors || '').split('|').filter(Boolean);
      const firstAvailableColor = visibleValues[0]
        || ((variants.find((variant) => variant.available) || {})['option' + (colorIdx + 1)])
        || (options[colorIdx] && options[colorIdx].values[0])
        || '';
      currentState.selectedColor = firstAvailableColor;
    }

    renderSheetColors();
    renderSheetSizes();
    updateSheetThumb();

    // Update ATC/stock based on current selection
    updateSheetState();

    if (typeof sheet.showModal === 'function') sheet.showModal();
    else sheet.setAttribute('open', '');
  }

  function selectSize(sizeVal) {
    if (!currentState) return;
    currentState.selectedSize = sizeVal;
    sheet.querySelectorAll('.mm-col-sheet__size').forEach((b) => {
      b.classList.toggle('is-active', b.dataset.value === sizeVal);
    });
    if (sheetSizeValue) sheetSizeValue.textContent = sizeVal;
    updateSheetState();
  }

  function findMatchingVariant() {
    if (!currentState) return null;
    const { variants, options, selectedColor, selectedSize } = currentState;
    const colorIdx = getColorIndex(options);
    const sizeIdx = getSizeIndex(options);
    return variants.find((v) => {
      const colorMatch = colorIdx < 0 || optionValue(v, colorIdx) === selectedColor;
      const sizeMatch = sizeIdx < 0 || optionValue(v, sizeIdx) === selectedSize;
      return colorMatch && sizeMatch;
    });
  }

  function updateSheetState() {
    if (!currentState) return;
    const matching = findMatchingVariant();
    const displayVariant = getDisplayVariant();
    const price = displayVariant ? displayVariant.price : 0;

    if (sheetPrice) sheetPrice.textContent = formatMoney(price);
    if (sheetAtcPrice) sheetAtcPrice.textContent = formatMoney(price);

    const hasSize = getSizeIndex(currentState.options) >= 0;
    const needsSize = hasSize && !currentState.selectedSize;
    const isAvailable = matching && matching.available;
    const colorIdx = getColorIndex(currentState.options);
    const hasAvailableForColor = currentState.variants.some((variant) => (
      variant.available && (colorIdx < 0 || optionValue(variant, colorIdx) === currentState.selectedColor)
    ));

    if (needsSize && !hasAvailableForColor) {
      sheetAtc.disabled = true;
      sheetAtcLabel.textContent = 'Agotado';
      sheetStock.hidden = false;
      sheetStock.dataset.status = 'out';
      if (sheetStockText) sheetStockText.textContent = 'Agotado';
    } else if (needsSize) {
      sheetAtc.disabled = true;
      sheetAtcLabel.textContent = 'Elige una talla';
      sheetStock.hidden = true;
    } else if (!isAvailable) {
      sheetAtc.disabled = true;
      sheetAtcLabel.textContent = 'Agotado';
      sheetStock.hidden = false;
      sheetStock.dataset.status = 'out';
      if (sheetStockText) sheetStockText.textContent = 'Agotado';
    } else {
      sheetAtc.disabled = false;
      sheetAtcLabel.textContent = 'Agregar al carrito';
      sheetStock.hidden = false;
      sheetStock.dataset.status = 'in';
      if (sheetStockText) sheetStockText.textContent = 'En stock';
    }
  }

  if (sheetAtc) {
    sheetAtc.addEventListener('click', async () => {
      const matching = findMatchingVariant();
      if (!matching || !matching.available) return;
      sheetAtc.disabled = true;
      sheetAtcLabel.textContent = 'Agregando…';
      try {
        if (window.MMCart && typeof window.MMCart.add === 'function') {
          await window.MMCart.add({
            id: matching.id,
            quantity: 1,
            productId: currentState && currentState.card ? currentState.card.dataset.productId : undefined,
            sourceId: 'mm-collection-sheet'
          });
        } else {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: matching.id, quantity: 1 })
          });
          if (!res.ok) throw new Error('add failed');
          await res.json();
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { data: { source: 'product-form-component', itemCount: 1 } }
          }));
          const drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') drawer.open();
        }
        sheetAtcLabel.textContent = '¡Agregado!';
        setTimeout(() => { sheet.close(); updateSheetState(); }, 700);
      } catch (err) {
        sheetAtcLabel.textContent = 'Error, reintenta';
        setTimeout(() => updateSheetState(), 1200);
      }
    });
  }

  if (sheetClose) sheetClose.addEventListener('click', () => sheet.close());
  if (sheet) sheet.addEventListener('click', (e) => { if (e.target === sheet) sheet.close(); });
  };

  const bootAll = () => {
    document.querySelectorAll('[data-mm-col]').forEach(boot);
  };

  bootAll();

  // Horizon can replace the complete collection section after filtering or
  // sorting. External scripts are not re-executed by that DOM morph, so watch
  // for a fresh collection root and initialize it exactly once.
  if (!window.__mmCollectionRootObserver && document.body) {
    window.__mmCollectionRootObserver = new MutationObserver(bootAll);
    window.__mmCollectionRootObserver.observe(document.body, { childList: true, subtree: true });
  }
})();
